exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skills-progress-container[data-v-4cde9e00] {\n    overflow-x: auto;\n}\n.headcol[data-v-4cde9e00] {\n    position: absolute;\n    left: 20px;\n    top: auto;\n    width: 70px;\n    padding-top: 3px;\n}\ntable[data-v-4cde9e00] {\n    margin-left: 70px;\n}\ntable td[data-v-4cde9e00] {\n    padding: 0;\n}\ntable th.unit[data-v-4cde9e00],\ntable td.unit[data-v-4cde9e00] {\n    width: 38px;\n}\ntable th.delimiter-left[data-v-4cde9e00],\ntable td.delimiter-left[data-v-4cde9e00] {\n    border-right: 3px #aaa solid;\n}\n\n", ""]);

// exports
